export default "__VITE_ASSET__MjrT5gMW__"